module.exports = __webpack_public_path__ + "img/u8145.ac49ecfc.png";